import React, { createContext, useState, useContext } from 'react';
import apiRequest from "../services/Axios/Configs/configs";
import { toast } from "react-toastify";

const DataContext = createContext();

export const useData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
    const [data, setData] = useState({
        about_us: [],
        contact_us: [],
        blogs: [],
        blog: {},
        projects: [],
        project: {images:[]},
        home:{trust:[],site_settings:{collaboration_terms:""},Service:[],projects:[],comment:[],events:[],blogs:[],team:[]},
        slider:[],
        events:[],
        blogsCategory:[],
        latestBlogs:[],
        projectCategories:[],
        latestProjects:[],
        faq:[],

    });

    const [loading, setLoading] = useState(false); // وضعیت بارگذاری

    // تابع برای دریافت داده‌ها از سرور و ذخیره در کانتکست
    const fetchData = async (pageKey, apiUrl) => {
        setLoading(true);
        try {
            const response = await apiRequest.get(apiUrl);
            setData((prevData) => ({
                ...prevData,
                [pageKey]: response.data, // ذخیره داده‌ها برای هر صفحه با استفاده از کلید مربوطه
            }));
        } catch (error) {
            console.error("Error fetching data:", error);
            // toast.error('متاسفانه خطایی رخ داده است. مجددا امتحان کنید.');
        } finally {
            setLoading(false); // در هر صورت مقدار `loading` را false کنیم
        }
    };

    return (
        <DataContext.Provider value={{ data, loading, fetchData }}>
            {children}
        </DataContext.Provider>
    );
};
